module.exports = __webpack_public_path__ + "img/bg.aa326227.png";